import React from 'react';
import './About.css';

const About = () => {
  // Using a public Unsplash endpoint for a sample studio photo.
  // You can replace this URL with a local asset (e.g. /images/your-image.jpg)

  return (
    <section id="about" className="about-section">
      <div className="container about-container">
        <h2>About Us</h2>

        <div
          className="about-content"
          style={{ display: 'flex', gap: 24, alignItems: 'flex-start', justifyContent: 'space-between', flexWrap: 'wrap' }}
        >
          <div className="about-text" style={{ flex: '1 1 45%', minWidth: 260, maxWidth: '48%' }}>
            
            <p>
              Since 2003, Latha Photos & Videos have been capturing life's most precious moments into timeless visuals.
              From a passion for photography and videography, it has grown into a trusted event media service 
              name across Devakottai, Karaikudi, and other surrounding regions. Over these years,
              we refine our art with advanced shooting techniques, creative visual storytelling, 
              and detail-oriented production standards. 
            </p>
            <p>
              Be it weddings, family functions, cultural events, or special celebrations, we believe in delivering visually 
              striking content that our clients always treasure. With nearly two decades of experience, Latha Photos & Videos 
              combines tradition, creativity, and technology to bring your moments to life.
            </p>
          </div>

          {/* Right-side studio photo */}
          <div className="about-image" style={{ flex: '1 1 45%', minWidth: 260, maxWidth: '48%' }}>
            <img
              src="/images/gallery/about.png"
              alt="Latha Photos & Videos studio"
              style={{ width: '100%', height: 'auto', borderRadius: 12, boxShadow: '0 8px 18px rgba(2,6,23,0.36)' }}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
